import React from "react";
import { useTranslation } from "utilities/i18n";
import { useRouteMatch } from "react-router";
import { NavLink, Redirect, Route, Switch } from "polyrouter";
import { Layout } from "views/Main/Layouts";
import { LicenseKeysRouter } from "../Shared/LicenseKeys/LicenseKeysRouter";
import { ClaritiSetupRouter } from "./Setup/ClaritiSetupRouter";
import { InstancesRouter } from "./Instances/InstancesRouter";
import { EntitlementsRouter } from "./Entitlements/EntitlementsRouter";
import { AccessTokensRouter } from "./AccessTokens/AccessTokensRouter";
import { ProductCatalogRouter } from "./ProductCatalog/ProductCatalogRouter";
import { AuditEventsRouter } from "./AuditEvents/AuditEventsRouter";
import { ProtectedNavLink, ProtectedRoute } from "TsRoleGuards";

export const ClaritiRouter: React.FC = () => {
  const { t } = useTranslation();
  const detailsMatchView = useRouteMatch<{ view: string }>([
    "/manage/licensing/clariti/:view/details"
  ]);
  const detailsView = detailsMatchView?.params?.view;
  const isDetailsView = !!detailsView;

  let back;
  if (detailsMatchView) {
    let backButtonMessage;
    let persist;

    switch (detailsView) {
      case "purchased-products":
        backButtonMessage = t("PURCHASED_PRODUCTS");
        break;
      case "entitlements":
        backButtonMessage = t("ENTITLEMENT_other");
        break;
      case "access-tokens":
        backButtonMessage = t("ACCESS_TOKEN_other");
        break;
      case "license-keys":
        backButtonMessage = t("LICENSE_KEYS");
        break;
      case "product-catalog":
        backButtonMessage = t("PRODUCT_CATALOG");
        break;
      case "audit-events":
        backButtonMessage = t("AUDIT_EVENTS");
        break;
      default:
        backButtonMessage = t("UNKNOWN");
        break;
    }

    const backTo =
      detailsMatchView?.url?.split("/details")[0] ??
      "/manage/licensing/clariti";

    back = {
      to: backTo,
      title: backButtonMessage,
      iconDesc: backButtonMessage,
      persist: persist
    };
  } else {
    const backButtonMessage = t("LICENSING");
    back = {
      to: "/manage/licensing",
      title: backButtonMessage,
      iconDesc: backButtonMessage
    };
  }

  const { Sidebar } = Layout;
  return (
    <Layout back={back}>
      {!isDetailsView && (
        <Sidebar>
          <span className="title-capitalized">{t("CLARITI")}</span>
          <ul className="menu router">
            <li>
              <NavLink nest to="/setup">
                {t("SETUP")}
              </NavLink>
            </li>
            <li>
              <NavLink nest to="/purchased-products">
                {t("PURCHASED_PRODUCTS")}
              </NavLink>
            </li>
            <li>
              <NavLink nest to="/entitlements">
                {t("ENTITLEMENT_other")}
              </NavLink>
            </li>
            <li>
              <NavLink nest to="/access-tokens">
                {t("ACCESS_TOKEN_other")}
              </NavLink>
            </li>
            <li>
              <NavLink nest to="/license-keys">
                {t("LICENSE_KEYS")}
              </NavLink>
            </li>
            <li>
              <NavLink nest to="/product-catalog">
                {t("PRODUCT_CATALOG")}
              </NavLink>
            </li>
            <li>
              <ProtectedNavLink
                nest
                to="/audit-events"
                requirement="license:PolyRead"
              >
                {t("AUDIT_EVENTS")}
              </ProtectedNavLink>
            </li>
          </ul>
        </Sidebar>
      )}
      <Switch nest>
        <Route path="/setup">
          <ClaritiSetupRouter />
        </Route>
        <Route path="/purchased-products">
          <InstancesRouter />
        </Route>
        <Route path="/entitlements">
          <EntitlementsRouter />
        </Route>
        <Route path="/access-tokens">
          <AccessTokensRouter />
        </Route>
        <Route path="/license-keys">
          <LicenseKeysRouter />
        </Route>
        <Route path="/product-catalog">
          <ProductCatalogRouter />
        </Route>
        <ProtectedRoute path="/audit-events" requirement="license:PolyRead">
          <AuditEventsRouter />
        </ProtectedRoute>
        <Redirect nest to="/setup" />
      </Switch>
    </Layout>
  );
};
